import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import {
  integrationSchemaRegistry,
  patternFilterSchema,
  timePeriodSchema,
} from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { PagerdutyService } from '../../service';

export enum ListIncidentsStatusFilter {
  Triggered = 'triggered',
  Acknowledged = 'acknowledged',
  Resolved = 'resolved',
}

export type ListIncidentsConfig = typeof ListIncidentsConfig._.Config;

export const ListIncidentsConfig = IntegrationConfig.make({
  service: PagerdutyService,
  name: Integration_Handler_Names_Enum.ListIncidents,
  configSchema: z.object({
    timePeriod: timePeriodSchema,
    statusFilter: z
      .array(
        z.enum(ListIncidentsStatusFilter).register(integrationSchemaRegistry, {
          i18n: 'integrations.pagerduty.services.pagerduty.shared.list_incidents_status_filter',
        }),
      )
      .optional(),
    serviceNamePatternFilter: patternFilterSchema.optional(),
    teamNamePatternFilter: patternFilterSchema.optional(),
    shouldOnlyGenerateCsv: z.boolean().optional(),
  }),
});
